import React from "react";
import { Card } from "react-bootstrap";

const StudiPlayer = () => {
    return (
        <>
            <Card>
                <Card.Header>Studi</Card.Header>
                <Card.Body>
                    <div className="m-5 text-center">Coming soon</div>
                </Card.Body>
            </Card>
        </>
    )
}
export default StudiPlayer;
